const UPDATE_USER_CREATE = (state, payload) => {
  state.userCreate = payload
}

const UPDATE_USERS = (state, payload) => {
  state.users = payload
}

const UPDATE_USER_INFO = (state, payload) => {
  state.userInfo = payload
}

const UPDATE_GLOBAL_SNACKBAR = (state, payload) => {
  state.globalSnackbar = payload
}

const UPDATE_GLOBAL_BASE_MODAL_MESSAGE = (state, payload) => {
  state.globalBaseModalMessage = payload
}

const UPDATE_IMPORT_VIDEOS_LEFT = (state, payload) => {
  state.toImportVideosLeft = payload
}

const UPDATE_USER_PLAN_INFO = (state, payload) => {
  state.userPlanInfo = payload
}

const UPDATE_USER_PLAN_INFO_ATTRIBUTES = (state, payload) => {
  if (!state.userPlanInfo.hasOwnProperty('user')) {
    state.userPlanInfo = {
      user: {
        email: payload.email,
        name: payload.name,
      },
    }
  } else {
    state.userPlanInfo.user = {
      email: payload.email,
      name: payload.name,
    }
  }

  state.userInfo.email = payload.email
  state.userInfo.name = payload.name
}

const UPDATE_REFRESH_TOKEN = (state, payload) => {
  state.refreshToken = payload
}

const UPDATE_FIRST_ACCESS = (state, payload) => {
  state.userFirstAccess = payload
}

const UPDATE_ROUTED_VIDEO = (state, payload) => {
  state.routedVideo = payload
}

const UPDATE_MAIN_VIDEOS = (state, payload) => {
  state.mainVideos = payload
}
const UPDATE_ALL_FOLDERS = (state, payload) => {
  state.allFolders = payload
}

const UPDATE_MAIN_FOLDERS = (state, payload) => {
  state.mainFolders = payload
}

const UPDATE_DELETED_FOLDERS = (state, payload) => {
  state.deletedFolders = payload
}

const UPDATE_FOLDER_VIDEOS = (state, payload) => {
  state.folderVideos = payload
}

const UPDATE_SUB_FOLDER_VIDEOS = (state, payload) => {
  state.subFolderVideos = payload
}

const UPDATE_SUB_FOLDER = (state, payload) => {
  state.subFolder = payload
}

const UPDATE_PRODUCTS = (state, payload) => {
  state.products = payload
}

const UPDATE_ONLY_CUSTOMIZING = (state, payload) => {
  state.onlyCustomizing = payload
}

const UPDATE_JUST_FEW_CUSTOMIZING = (state, payload) => {
  state.justFewCustomizing = payload
}

const UPDATE_ACCOUNT_FOLDER_VIDEOS = (state, payload) => {
  state.accountFolderVideos = payload
}

const UPDATE_DID_FETCH_VIDEOS = (state, payload) => {
  state.didFetchVideos = payload
}

const UPDATE_SHOULD_FETCH_ALL_VIDEOS = (state, payload) => {
  state.shouldFetchAllVideos = payload
}
const UPDATE_WINDOW_INFO = (state, payload) => {
  state.windowWidth = payload
  state.isTabletBreakpoint = payload < 1093
  state.isMobileBreakpoint = payload < 768
}
const UPDATE_FETCH_PERMISSIONS = (state, payload) => {
  state.fetchPermissions = payload
}
const UPDATE_NAV_ITEMS = (state, payload) => {
  state.navItems = payload
}
const UPDATE_SETTINGS_NAV_ITEMS = (state, payload) => {
  state.settingsNavItems = payload
}
const UPDATE_SECURITY_NAV_ITEMS = (state, payload) => {
  state.securityNavItems = payload
}
const UPDATE_USER_PERMISSIONS = (state, payload) => {
  state.userPermissions = payload
}
const UPDATE_USER_ALLINFO = (state, payload) => {
  state.userAllInfo = payload
}
const UPDATE_USER_ALLINFO_IMAGE = (state, payload) => {
  if (state.userAllInfo) {
    state.userAllInfo.image_path = payload
  } else {
    state.userAllInfo = { image_path: payload }
  }
}
const UPDATE_USER_ALLINFO_NAME = (state, payload) => {
  if (state.userAllInfo) {
    state.userAllInfo.name = payload
  } else {
    state.userAllInfo = { name: payload }
  }
}
const UPDATE_DRM_GROUPS = (state, payload) => {
  state.drmData.drmGroups = payload
}
const UPDATE_CREDITS_TOGGLE = (state, payload) => {
  state.buyCreditsToggle = payload
}
const UPDATE_USER_RECAP_AVAILABILITY = (state, payload) => {
  state.isRecapAvailable = payload
}

export {
  UPDATE_USER_CREATE,
  UPDATE_USERS,
  UPDATE_USER_INFO,
  UPDATE_GLOBAL_SNACKBAR,
  UPDATE_GLOBAL_BASE_MODAL_MESSAGE,
  UPDATE_IMPORT_VIDEOS_LEFT,
  UPDATE_USER_PLAN_INFO,
  UPDATE_REFRESH_TOKEN,
  UPDATE_FIRST_ACCESS,
  UPDATE_ROUTED_VIDEO,
  UPDATE_MAIN_VIDEOS,
  UPDATE_ALL_FOLDERS,
  UPDATE_MAIN_FOLDERS,
  UPDATE_DELETED_FOLDERS,
  UPDATE_FOLDER_VIDEOS,
  UPDATE_SUB_FOLDER_VIDEOS,
  UPDATE_SUB_FOLDER,
  UPDATE_PRODUCTS,
  UPDATE_ONLY_CUSTOMIZING,
  UPDATE_JUST_FEW_CUSTOMIZING,
  UPDATE_ACCOUNT_FOLDER_VIDEOS,
  UPDATE_DID_FETCH_VIDEOS,
  UPDATE_SHOULD_FETCH_ALL_VIDEOS,
  UPDATE_WINDOW_INFO,
  UPDATE_USER_PLAN_INFO_ATTRIBUTES,
  UPDATE_FETCH_PERMISSIONS,
  UPDATE_NAV_ITEMS,
  UPDATE_SETTINGS_NAV_ITEMS,
  UPDATE_SECURITY_NAV_ITEMS,
  UPDATE_USER_PERMISSIONS,
  UPDATE_USER_ALLINFO,
  UPDATE_DRM_GROUPS,
  UPDATE_CREDITS_TOGGLE,
  UPDATE_USER_ALLINFO_IMAGE,
  UPDATE_USER_ALLINFO_NAME,
  UPDATE_USER_RECAP_AVAILABILITY,
}
